import Subtitle from "components/Subtitle/subtitle.component";
import dompurify from "dompurify";
import { saveAs } from "file-saver";
import { LoadingStyle } from "pages/comum/Layout/layout.style";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import exportService from "services/exportaPDFService";
import GenericAlert from "../../../components/Alert/genericAlert.component";
import Button from "../../../components/Button/button.component";
import Label from "../../../components/Label/label.component";
import Table from "../../../components/Table/table.component";
import Title from "../../../components/Title/title.component";
import { ALERTAS_PERMISSIONS } from "../../../constants/index";
import { Creators as AnaliseActions } from "../../../store/ducks/alertas/analise";
import { Creators as DownloadActions } from "../../../store/ducks/comum/download";
import FileHelper from "../../../utils/fileHelpers";

const mapStateToProps = state => ({
	registro: state.analise.registro,
	monitoramento: state.analise.monitoramento,
	arquivo: state.download.arquivo,
	responsavel: state.analise.responsavel,
	dataAcao: state.analise.dataAcao,
	responsavelEmissao: state.analise.responsavelEmissao,
	dataHoraEmissao: state.analise.dataHoraEmissao
});

const mapDispatchToProps = dispatch => ({
	AnaliseActions: bindActionCreators(AnaliseActions, dispatch),
	DownloadActions: bindActionCreators(DownloadActions, dispatch)
});

class CadastroAnalise extends Component {
	state = {
		loading: false
	};

	columns = [
		{ id: 0, title: "Origem", property: "origem.nome" },
		{ id: 1, title: "Descrição", property: "descricao" },
		{ id: 2, title: "Data ", property: "dataAnalise" },
		{ id: 3, title: "Hora ", property: "horaAnalise" },
		{ id: 4, title: "Responsável", property: "responsavel" }
	];

	actions = [
		{
			id: 0,
			name: "Download da imagem",
			icon: "fas fa-download",
			action: item => this.downloadFile(item)
		}
	];

	componentDidMount() {
		const { AnaliseActions: analiseActions, alertaId } = this.props;

		this.setLoading(true);
		analiseActions.analiseBuscarPorAlertaId(
			alertaId,
			this.setLoading.bind(this)
		);
	}

	setLoading(loading) {
		this.setState({ loading });
	}

	downloadFile = async registro => {
		const { DownloadActions: downloadActions } = this.props;

		downloadActions.downloadFile(registro.documento, arquivo => {
			const fileSignature = FileHelper.buf2hex(arquivo);
			const fileMimeType = FileHelper.getMimetype(
				fileSignature.slice(0, 8)
			);

			const blob = new Blob([arquivo], { type: fileMimeType });
			saveAs(blob, registro.documento.nome);
		});
	};

	handleExportar = async () => {
		const {
			monitoramento: { id }
		} = this.props;
		const { data: arquivo } = await exportService.exportAnalisePDF(id);
		const blob = new Blob([arquivo], { type: "application/pdf" });

		const date = new Date();
		const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
		const month =
			date.getMonth() + 1 > 9
				? date.getMonth() + 1
				: `0${date.getMonth() + 1}`;

		const year = `${day}-${month}-${date.getFullYear()}`;

		const minutes =
			date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
		const seconds =
			date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
		const hours =
			date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;

		const time = `${hours}-${minutes}-${seconds}`;

		const fileName = `Relatório_de_análise-${year}_${time}`;
		saveAs(blob, fileName);
	};

	innerHTMLPurified = text => {
		const textToBeSanitizer = text;
		const sanitizer = dompurify.sanitize;

		// eslint-disable-next-line react/no-danger
		return (
			<span
				dangerouslySetInnerHTML={{
					__html: sanitizer(textToBeSanitizer) || " "
				}}
			/>
		);
	};

	getFormatedData = registros => {
		const formatedRegistros = [];

		registros.forEach(element => {
			const registro = {};
			registro.horaAnalise = (element.horaAnalise || "").substring(5, 0);
			registro.dataAnalise = element.dataAnalise;
			registro.descricao = element.descricao;
			registro.documento = element.documento;
			registro.id = element.id;
			registro.origem = element.origem;
			registro.responsavel = element.responsavel;

			formatedRegistros.push(registro);
		});
		return formatedRegistros;
	};

	render() {
		const {
			monitoramento: { registroMonitoramento, alertaStatus },
			onClick,
			handleBackButton,
			responsavel,
			dataAcao,
			responsavelEmissao,
			dataHoraEmissao
		} = this.props;
		return (
			<div className="mt-3">
				{this.state.loading && (
					<LoadingStyle className="loading">
						<div className="text-center">
							<div className="spinner-border" role="status" />
						</div>
					</LoadingStyle>
				)}
				{/* CARD PARA ALERTAS ATIVOS E FINALIZADOS */}
				{
					<GenericAlert
						type="primary"
						body={
							<div>
								<Subtitle style={{ color: "#134265" }}>
									Informações sobre o alerta
								</Subtitle>
								<div
									className="row"
									style={{ paddingTop: "15px" }}
								>
									<Label
										label="Status"
										text={
											((alertaStatus || {}).status || {})
												.nome || " ---"
										}
										col={4}
									/>

									<Label
										label={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? "Data/Hora da emissão"
												: "Data/Hora"
										}
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? dataHoraEmissao
												: dataAcao
										}
										col={4}
									/>

									<Label
										label="Responsável"
										text={
											((alertaStatus || {}).status || {})
												.nome === "Ativo"
												? responsavelEmissao
												: responsavel
										}
										col={4}
									/>
								</div>
								{(((alertaStatus || {}).status || {}).nome ===
									"Cessado" ||
									((alertaStatus || {}).status || {}).nome ===
										"Cancelado") && (
									<div className="row">
										<Label
											label="Mensagem"
											text={this.innerHTMLPurified(
												(alertaStatus || {}).mensagem ||
													" ---"
											)}
										/>
									</div>
								)}
							</div>
						}
					/>
				}

				<div className="container content-container">
					<div className="row mt-2">
						<div className="col-6">
							<Title>Análise</Title>
						</div>
						<div className="col-6">
							<div className="float-right">
								<Button
									type="button"
									primary
									text="Exportar PDF"
									icon="fas fa-file-pdf"
									onClick={() => this.handleExportar()}
								/>
							</div>
						</div>
					</div>
					<hr />

					<Table
						acoesSingleButton
						columns={this.columns}
						actions={this.actions}
						data={this.getFormatedData(registroMonitoramento)}
						emptyMessage="Não há registros cadastrados."
						emptyColSpan={this.columns.length + 1}
						permission={ALERTAS_PERMISSIONS.VISUALIZAR}
					/>
				</div>
				<div className="row mt-3">
					<div className="col-md-6">
						<div className="float-left">
							<Button
								type="button"
								cancel
								text="Sair"
								icon="fas fa-times"
								onClick={() => handleBackButton()}
							/>
							<Button
								onClick={() => onClick("geo")}
								type="submit"
								primary
								text="Voltar"
								icon="fas fa-arrow-left"
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="float-right">
							<Button
								onClick={() => onClick("audiencia")}
								type="submit"
								primary
								text="Próximo"
								icon="fas fa-arrow-right"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CadastroAnalise);
